// The street's four looks (morning, day, evening, night): ChatGPT repaints of the same panorama, one per
// phase of the day cycle (state/dayCycle.js), with the sky cut out — the farm's sky is drawn behind them
// (street/StreetSky.js). scripts/street_looks.py makes them and prints the two numbers below. Pure (node --test).
import { STREET_TILES, STREET_SCALE, STREET_SRC_H, STREET_WORLD_WIDTH } from '../streetSpawns.mjs';

export const STREET_LOOKS = ['night', 'morning', 'day', 'evening'];

// Source rows cut off the top of every tile (pure sky in every look), and the lowest source row with any sky in
// the mask: everything below it is opaque street. From `street_looks.py cut`, 2026-10-27.
export const STREET_SKY_CROP = 130;
export const STREET_HORIZON_SRC_Y = 552;
export const STREET_HORIZON_Y = STREET_HORIZON_SRC_Y * STREET_SCALE;

// The sky's pan as you walk (street/StreetSky.js), fed to the farm's sky parts, which take their own parallax share
// of it (near clouds 0.18, far clouds 0.08, sun 0.05). 2.2x makes the near clouds slide ~40% of the walk and the sun
// ~11%. It is 0 mid-street, so the sun is where the clock puts it there and ~280 px off it at either end.
export const STREET_SKY_PAN = 2.2;
export function streetSkyPanX(scrollX, viewW) {
  return -(scrollX - (STREET_WORLD_WIDTH - viewW) / 2) * STREET_SKY_PAN;
}

export function lookFor(phase) {
  return STREET_LOOKS.includes(phase) ? phase : 'day';
}

export function nextLook(look) {
  return STREET_LOOKS[(STREET_LOOKS.indexOf(lookFor(look)) + 1) % STREET_LOOKS.length];
}

export function streetTileKeys(look) {
  return STREET_TILES.map((_, i) => `bg_street_${look}_${i}`);
}

// Where each tile goes, in world units (top-left origin).
export function streetTileRects(look) {
  const keys = streetTileKeys(look);
  return STREET_TILES.map((t, i) => ({
    key: keys[i],
    x: t.srcX * STREET_SCALE,
    y: STREET_SKY_CROP * STREET_SCALE,
    w: t.srcW * STREET_SCALE,
    h: (STREET_SRC_H - STREET_SKY_CROP) * STREET_SCALE,
    originX: 0,
    originY: 0,
  }));
}

// What to fetch after the current look: the next one first (the street crossfades into it), then — not on
// phones — the other two in the order they come.
export function streetPrefetch(look, { lean = false } = {}) {
  const next = nextLook(look);
  const after = nextLook(next);
  return [...streetTileKeys(next), ...(lean ? [] : [...streetTileKeys(after), ...streetTileKeys(nextLook(after))])];
}

// Shops closed at night (owner, 2026-10-27): every door but the Game Hall's. Nobody is sent out — a player
// already inside stays, and coming out works as always; only walking in at night is refused.
export const CLOSED_AT_NIGHT = new Set(['CAR_DEALER', 'DRIVING_SCHOOL', 'BIKE_SHOP', 'FURNITURE', 'CLOTHING', 'PET', 'SHOP']);
export const CLOSED_TOAST = 'Zamknięte — zapraszamy rano {moon}';

export function doorClosed(doorKey, phase) {
  return phase === 'night' && CLOSED_AT_NIGHT.has(doorKey);
}
